import {
  MIN_TOKEN_VALIDITY_SECONDS,
} from '@qmulus/ui/api/authentication.ts';
import axios from 'axios';
import qs from 'qs';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config.js';
import {
  Thunder as pt9800Thunder,
  apiFetch as pt9800ApiFetch,
} from '@/pt9800/generated/zeus';

const pt9800GraphqlClient: ReturnType<typeof pt9800Thunder> = pt9800Thunder(async (zeus, variables) => {
  await keycloakAuthenticationHandler.keycloak.updateToken(MIN_TOKEN_VALIDITY_SECONDS);
  return pt9800ApiFetch([
    `${config.VITE_APP_API_PT9800_URL}/graphql`,
    {
      headers: {
        'Authorization': `Bearer ${keycloakAuthenticationHandler.keycloak.token}`,
        'x-pt-location': variables!.location as string,
        'content-type': 'application/json',
      },
    },
  ])(zeus, variables);
});

const pt9800GraphqlClientQuery = pt9800GraphqlClient('query');
// const pt9800GraphqlClientMutation = pt9800GraphqlClient('mutation');

function buildAxiosClient(baseURL: string) {
  const client = axios.create({
    baseURL: baseURL,
    withCredentials: true,
    paramsSerializer(params) {
      return qs.stringify(params, {
        arrayFormat: 'repeat',
      });
    },
  });

  keycloakAuthenticationHandler.secureAxiosClient(client);

  return client;
}

const axiosClientBase = buildAxiosClient(config.VITE_APP_API_URL);
const axiosClientV3 = buildAxiosClient(`${config.VITE_APP_API_URL}/v3`);
const axiosClientV3Npm = buildAxiosClient(`${config.VITE_APP_API_URL}/v3/npm/api`);
const axiosClientRestPT9800 = buildAxiosClient(
  // we utilize the Qmulus API proxy here to record each activity in Audit Trail
  // baseURL: `${config.VITE_APP_API_URL}/protherm`,
  // todo: Pointed back to actual PT9800 API due to various wrong OpenAPI annotations
  //  in PT9800 API that cause 500 errors on the proxy. This state is not desirable,
  //  as it circumvents the audit trail
  `${config.VITE_APP_API_PT9800_URL}/restApi`,
);
const axiosClientPT9800 = buildAxiosClient(config.VITE_APP_API_PT9800_URL);

export default axiosClientV3;
export {
  axiosClientBase,
  axiosClientPT9800,
  axiosClientRestPT9800,
  axiosClientV3,
  axiosClientV3Npm,
  pt9800GraphqlClient,
  pt9800GraphqlClientQuery,
};
